<template>
  <div class="app" :class="{ 'energy-default': themeCode === 'default', 'energy': themeCode === 'blue' }">
    <div class="energy-content">
      <div class="energy-content-left">
        <div class="energy-title">{{ $t('abnormal.abnormal.628134-0') }}</div>
        <div class="map-left-search">
          <img @click="searchDevice"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaElEQVQ4jY2TsUtVYRjGf95Eu6DkxYi7uEaGQQqBNASB2tYkBNEYCEWLOLm1BgX+B4I4dsEhFGlpaXFQCgeXCKUQDAWxaBB/8cV79fPck90HHjjne9734fB8z+lQyXANeAhMALeAKvAF+AA0gM8UkQyC4+qaZ9hVv2bvB+qM2pXtnBo8UPdjcFV9rI6oN0ObU49Df1U0qKufQnyjXskHMibTXzE3mRs8jcMVtbdkMefLmH2vVpsG79QT9UnJQpED6pH6XR1OWgW4ARwCWy0Jt+IbsAn0A7WkJoOTdBnx3A4u5TOVcOwDrrexPAAMAT+AvabB2xCngN6WlfN4AXQDG1GwvyHWsgLNq1dLwkt8rv5Wf0bpzhXprrodJpvqtHpPHVUfqY2skbNqZ9Eg8Y76MRssYkedUl+rS80vLf5MPcAkcB+oR+LpiteBBWAfWIvAl4FnF5Um/TSXS84H88z+17x/8ba6qI79Ac8cMX/xveWyAAAAAElFTkSuQmCC"
            :alt="$t('abnormal.abnormal.628134-1')">
          <input @keyup.enter="searchDevice" type="text" v-model="OwnerName"
            :placeholder="$t('abnormal.abnormal.628134-2')" />
        </div>
        <div class="report-content-left-lists">
          <div v-for="item in RoshRoomAllList" :key="item.Id">
            <div class="report-content-left-item" :class="{ 'map-left-lists-society-unselected': expandItem.Id === item.Id }"
              @click="expandClick(item)">
              <div class="report-content-left-item-view">
                <div class="report-content-left-item-view-inco ">
                  <img :src="require('../../../assets/electricity/room.png')" />
                </div>
                <div class="report-content-left-item-view-device">
                  <div class="device-text">{{ item.OwnerName }}</div>
                  <div class="device-code">{{ item.AddressDetail || '-' }}</div>
                </div>
              </div>
              <div class="report-content-left-item-img">
                <img src="../../../assets/electricity/arrow.png" alt="">
              </div>
            </div>
            <div class="report-content-left-lisk" v-if="expandItem.Id === item.Id">
              <div class="report-content-left-lisk-item"
                :class="{ 'report-content-left-lisk-select': deviceItem.Id === item.Id }" v-for="(item) in DeviceLists"
                :key="item.Id" @click="selectDevice(item)">
                <div class="item-detail">
                  <div class="report-content-left-lisk-item-inco mapRightRroupListItemImgColor1">
                    <img v-if="item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                      :src="item.IsOnline ? require('../../../assets/electricity/weiduan.png') : require('../../../assets/electricity/weiduan1.png')" />
                    <img v-if="item.DeviceId == '4782d02c-0075-4105-9729-aa1b65bb250a'"
                      :src="item.IsOnline ? require('../../../assets/electricity/yangan.png') : require('../../../assets/electricity/yangan1.png')" />
                    <img v-if="item.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857'"
                      :src="item.IsOnline ? require('../../../assets/electricity/qigan.png') : require('../../../assets/electricity/qigan1.png')" />
                    <img v-if="item.DeviceId == '7febbea4-0326-496d-9b71-5b058729cb42'"
                      :src="item.IsOnline ? require('../../../assets/electricity/chuanganqi.png') : require('../../../assets/electricity/chuanganqi1.png')" />
                  </div>
                  <div class="report-content-left-lisk-item-device">
                    <div class="device-name">{{ item.UserDeviceName }}</div>
                    <div class="device-id">{{ item.DeviceCode }}</div>
                  </div>
                </div>
                <div class="item-arrow">
                  <img
                    src="data:image/png;base64,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"
                    alt="">
                </div>
              </div>
              <div class="map-right-group-list-none1" v-if="!DeviceLists.length">{{ $t('abnormal.abnormal.628134-3') }}
              </div>
            </div>
          </div>

        </div>

        <div class="report-content-left-page">
          <Page :total="TotalCount" @on-change="deviceChange" size="small" />
        </div>
      </div>
      <div class="energy-content-right">
        <div class="energy-content-r-top">
          <div>
            <Select v-model="type" style="width:10vw" :placeholder="$t('abnormal.abnormal.628134-4')">
              <Option value="ri">{{ $t('abnormal.abnormal.628134-5') }}</Option>
              <Option value="yue">{{ $t('abnormal.abnormal.628134-6') }}</Option>
              <Option value="ji">{{ $t('abnormal.abnormal.628134-7') }}</Option>
              <Option value="nian">{{ $t('abnormal.abnormal.628134-8') }}</Option>
              <Option value="zi">{{ $t('abnormal.abnormal.628134-9') }}</Option>
            </Select>
          </div>
          <div v-if="type == 'zi'">
            <DatePicker v-model="times" format="yyyy-MM-dd" type="daterange" placement="bottom-end"
              :placeholder="$t('abnormal.abnormal.628134-10')" style="width: 10vw"></DatePicker>
          </div>
          <div>
            <Button type="primary" @click="inquireClick">{{ $t('abnormal.abnormal.628134-11') }}</Button>
          </div>
          <div>
            <Button type="success" @click="exportClick">{{ $t('abnormal.abnormal.628134-12') }}</Button>
          </div>
        </div>
        <div class="energy-content-r-content">
          <div class="abnormal-left">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']"
              :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('abnormal.abnormal.628134-13') }}</div>
              <div class="energy-time-echarts">
                <div id="initAbnormalEcharts" style="width: 100%; height: 100%;"></div>
              </div>
            </dv-border-box-7>
          </div>
          <div class="abnormal-right">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']"
              :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('abnormal.abnormal.628134-14') }}</div>
              <div class="energy-time-echarts">
                <div id="initTimeEcharts" style="width: 100%; height: 100%;"></div>
              </div>
            </dv-border-box-7>
          </div>
          <div class="abnormal-content">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']"
              :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('abnormal.abnormal.628134-15') }}</div>
              <div class="energy-time-echarts">
                <div id="initReasonEcharts" style="width: 100%; height: 100%;"></div>
              </div>
            </dv-border-box-7>
          </div>

        </div>
        <div class="energy-content-r-footer">
          <div class="r-footer-left">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']"
              :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('abnormal.abnormal.628134-16') }}</div>
              <div class="energy-time-echarts">
                <div id="initEnergyEcharts" style="width: 100%; height: 100%;"></div>
              </div>
            </dv-border-box-7>
          </div>
          <div class="r-footer-right">
            <dv-border-box-7 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']"
              :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
              <div class="energy-title">{{ $t('abnormal.abnormal.628134-17') }}</div>
              <div class="energy-ranking">
                <div class="map-bottom-content-tab">
                  <div class="map-bottom-content-tab-item">{{ $t('abnormal.abnormal.628134-18') }}</div>
                  <div class="map-bottom-content-tab-item">{{ $t('abnormal.abnormal.628134-19') }}</div>
                  <div class="map-bottom-content-tab-item">{{ $t('abnormal.abnormal.628134-20') }}</div>
                  <div class="map-bottom-content-tab-item tabHandle">{{ $t('abnormal.abnormal.628134-21') }}</div>
                </div>
                <div class="map-bottom-list">
                  <div class="map-bottom-lists" v-if="DeviceAbnormalPageLists.length > 0">
                    <div class="map-bottom-list-item" v-for="item in DeviceAbnormalPageLists" :key="item.Id">
                      <div class="map-bottom-list-item-device">{{ item.UserDeviceName }}</div>
                      <div class="map-bottom-list-item-addr">{{ item.DeviceCode }}</div>
                      <div class="map-bottom-list-item-date">{{ item.AbnormalName }}</div>
                      <div class="map-bottom-list-item-handle" :title="item.AbnormalTime">{{ item.AbnormalTime }}</div>
                    </div>
                  </div>
                  <div v-else class="map-right-group-list-none">{{ $t('abnormal.abnormal.628134-22') }}</div>
                </div>
                <div class="user-top-list-page">
                  <Page :total="DeviceAbnormalTotalCount" :current="DeviceAbnormalIndex" :page-size="DeviceAbnormalSize"
                    @on-change="DeviceAbnormalChange" @on-page-size-change="DeviceAbnormalSizeChange" size="small"
                    show-sizer placement="top" show-total />
                </div>
              </div>
            </dv-border-box-7>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import Cookies from 'js-cookie'
import api from '../../../api/request.js'
export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      OwnerName: '', // 搜索
      DeviceLists: [], // 设备列表
      TotalCount: 0, // TotalCount
      deviceItem: {
        Id: '',
        DeviceCode: '',
        DeviceName: '',
      },
      times: [],
      type: 'ri',

      DeviceAbnormalPageLists: [], // 异常列表
      DeviceAbnormalIndex: 1,
      DeviceAbnormalSize: 10,
      DeviceAbnormalTotalCount: 0,

      nameLists: [],
      valueLists: [],

      RoshRoomAllList: [],
      expandItem: {},
      initState: true, // 是否首次进入页面

      themeCode: '',
    }
  },

  created() {
    let _this = this;
    _this.themeCode = _this.$store.getters.getThemeCode;
  },

  computed: {

  },

  mounted() {
    let _this = this;

    // 获取当天时间
    _this.getTiemDate();

    _this.GetRoshRoomAll();

    // 根据集团 公司 部门编号 等条件查询设备列表
    // _this.GetUserDevicesPage();

    // 异常占比
    // _this.initAbnormalEcharts();
    // 异常原因
    // _this.initReasonEcharts();
    // 时分比
    // _this.initTimeEcharts();
    // 能耗同比
    // _this.initEnergyEcharts();
  },

  methods: {

    // 加载导航栏用户列表
    GetRoshRoomAll() {

      if (!Cookies.get('AdminData')) {
        if (window.location.host == 'xed.hxpwr.com') {
          this.$router.push({
            name: 'xed_login'
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get('AdminData'));

      let data = {
        Status: 'A',
        GroupCode: AdminData.GroupCode,
        CompanyCode: AdminData.CompanyCode,
        DepartmentCode: AdminData.DepartmentCode,
        pageIndex: _this.pageIndex,
        pageSize: _this.pageSize,
        OwnerName: _this.OwnerName
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/User/GetRoshRoomAll',
        data: data,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }).then(function (res) {
        _this.RoshRoomAllList = res.Data;
        _this.TotalCount = res.TotalCount;

        if (_this.initState && _this.RoshRoomAllList.length) {
          _this.expandClick(_this.RoshRoomAllList[0], 'init')
          _this.initState = false
        }

      }).catch(function (err) {

      });
    },

    expandClick(item, type = '') {
      if (item.Id !== this.expandItem.Id) {
        this.expandItem = item;
        this.GetUserDevicesPage(type)
      } else {
        this.expandItem = {}
      }

    },

    // 获取当天时间
    getTiemDate() {
      let _this = this;
      var date = new Date();
      date.setMonth(date.getMonth() - 1);
      var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

      var dates = new Date();
      var dateStrings = dates.getFullYear() + "-" + (dates.getMonth() + 1) + "-" + dates.getDate();

      _this.times = [dateString, dateStrings];
    },
    // 根据集团 公司 部门编号 等条件查询设备列表
    GetUserDevicesPage(type = '') {
      let AdminData = JSON.parse(Cookies.get('AdminData'));
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/CommElecDevice/GetUserDevicesPage?isAdmin=${AdminData.IsAdmin}&groupCode=${this.expandItem.GroupCode}&companyCode=${this.expandItem.CompanyCode}&departmentCode=${this.expandItem.DepartmentCode}&pageIndex=1&pageSize=100&roomNo=${this.expandItem.RoomCode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.DeviceLists = res.Data;
          // _this.TotalCount = res.TotalCount;
          if (!_this.deviceItem.Id && type === 'init') {
            if (!_this.deviceItem.Id) {
              if (!res.Data[0]) return;
              _this.deviceItem = {
                Id: res.Data[0].Id,
                DeviceCode: res.Data[0].DeviceCode,
                DeviceName: res.Data[0].UserDeviceName,
              }
              // 获取异常占比
              _this.YiCangZanBi();
              if (_this.type == 'zi') {
                // 根据时间进行异常统计
                _this.GetYiCangTongJiByDate();
              } else {
                _this.GetYiCangTongJi();
                if (_this.type == 'ji') {
                  // 季异常
                  _this.AbnormalBiliJi();
                } else {
                  // 异常同比
                  _this.AbnormalBili();
                }
              }

              // 根据设备编号获取异常
              _this.GetDeviceAbnormalPageList();
            }
          }

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    deviceChange(value) {
      let _this = this;
      _this.pageIndex = value;
      _this.GetRoshRoomAll()
    },
    // 搜索设备
    searchDevice() {
      let _this = this;
      _this.pageIndex = 1;
      _this.GetRoshRoomAll();
    },
    // 选择设备
    selectDevice(item) {
      let _this = this;
      _this.deviceItem = {
        Id: item.Id,
        DeviceCode: item.DeviceCode,
        DeviceName: item.UserDeviceName,
      }
      // 获取异常占比
      _this.YiCangZanBi();
      if (_this.type == 'zi') {
        // 根据时间进行异常统计
        _this.GetYiCangTongJiByDate();
      } else {
        _this.GetYiCangTongJi()
        if (_this.type == 'ji') {
          // 季异常
          _this.AbnormalBiliJi();
        } else {
          // 异常同比
          _this.AbnormalBili();
        }
      }
      // 根据设备编号获取异常
      _this.GetDeviceAbnormalPageList();
    },
    // 获取异常占比
    YiCangZanBi() {
      let _this = this;
      let dt = '';
      if (_this.type == 'zi') {
        if (!_this.times[0]) {
          _this.$Message['error']({
            background: true,
            content: _this.$t('abnormal.abnormal.628134-23')
          });
          return;
        }
        dt = `&startDt=${_this.formDate(_this.times[0])}&endDt=${_this.formDate(_this.times[1])}`;
      }
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/YiCangZanBi?deviceCode=${_this.deviceItem.DeviceCode}&type=${_this.type}` + dt,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          let AbnormalEcharts = [];
          res.Data.forEach((item, index) => {
            AbnormalEcharts.push({
              value: item.value,
              name: item.name
            })
          })
          if (AbnormalEcharts.length == 0) {
            AbnormalEcharts.push({
              value: 0,
              name: _this.$t('abnormal.abnormal.628134-24')
            })
          }
          _this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById('initAbnormalEcharts'));
            myChart.dispose();
            _this.initAbnormalEcharts(AbnormalEcharts);

            let myChart1 = echarts.init(document.getElementById('initReasonEcharts'));
            myChart1.dispose();
            _this.initReasonEcharts(AbnormalEcharts);

          });
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 根据时间进行异常统计
    GetYiCangTongJiByDate() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetYiCangTongJiByDate?deviceCode=${_this.deviceItem.DeviceCode}&startDt=${_this.formDate(_this.times[0])}&endDt=${_this.formDate(_this.times[1])}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {

          let nameLists = [], valueLists = [], sValueLists = [];
          res.Data.forEach((item, index) => {
            let list = item.name.split('/');
            nameLists.push(`${list[1]}-${list[2]}`);
            valueLists.push(item.value);
            sValueLists.push('-');
          })
          _this.GetZiTong(nameLists, valueLists, sValueLists);

          _this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById('initTimeEcharts'));
            myChart.dispose();
            _this.initTimeEcharts(nameLists, valueLists);
          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 自定义时间同比
    GetZiTong(nameLists, valueLists, sValueLists) {
      let _this = this;

      _this.$nextTick(() => {
        let myChart = echarts.init(document.getElementById('initEnergyEcharts'));
        myChart.dispose();
        _this.initEnergyEcharts(valueLists, sValueLists, nameLists);
      });
    },
    // 获取异常统计
    GetYiCangTongJi() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetYiCangTongJi?deviceCode=${_this.deviceItem.DeviceCode}&type=${_this.type}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {

          let nameLists = [], valueLists = [];
          res.Data.forEach((item, index) => {
            nameLists.push(item.name);
            valueLists.push(item.value);
          })
          _this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById('initTimeEcharts'));
            myChart.dispose();
            _this.initTimeEcharts(nameLists, valueLists);
          });

        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 异常占比
    initAbnormalEcharts(AbnormalEcharts) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('initAbnormalEcharts'))
      // 绘制图表
      myChart.setOption({
        color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {d}%'
        },
        series: [{
          name: _this.$t('abnormal.abnormal.628134-13'),
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],
          data: AbnormalEcharts,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    // 异常原因
    initReasonEcharts(AbnormalEcharts) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('initReasonEcharts'))
      // 绘制图表
      myChart.setOption({
        color: ['#F6580E', '#2E8CFF', '#F6D10E', '#FD9133', '#858FF8', '#19CA88', '#37D2D4'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c}'
        },
        series: [{
          name: _this.$t('abnormal.abnormal.628134-15'),
          type: 'pie',
          radius: ['30%', '55%'],
          avoidLabelOverlap: false,
          data: AbnormalEcharts
        }]
      });
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    // 时分比
    initTimeEcharts(nameLists, valueLists) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('initTimeEcharts'))
      // 绘制图表
      myChart.setOption({
        color: ['#37D2D4', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '2%',
          top: '5%',
          right: '3%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: nameLists,
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ccc',
              fontSize: 10
            },
          },
          axisTick: { //y轴刻度线
            show: false
          },
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ccc',
              fontSize: 10
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.2)"
            }
          },
          axisTick: {
            show: false
          },
        }],
        series: [{
          name: _this.$t('abnormal.abnormal.628134-14'),
          type: 'line',
          smooth: true,
          stack: _this.$t('abnormal.abnormal.628134-25'),
          areaStyle: {},
          data: valueLists,
          itemStyle: {
            normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(55,210,212,0.3)' // 0% 处的颜色
              }, {
                offset: 0.5,
                color: 'rgba(55,210,212,0.1)'
              }, {
                offset: 1,
                color: 'rgba(55,210,212,0.0)' // 100% 处的颜色
              }]), //背景渐变色
              lineStyle: { // 系列级个性化折线样式
                color: 'rgba(55,210,212,1)'
              }
            },
            emphasis: {
              color: 'rgba(55,210,212,1)'
            }
          }, //线条样式

        }]
      });
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    // 异常同比事件
    async AbnormalBili() {
      let _this = this;
      // 同期
      const Tabnormal = await _this.GetYiCangTongJiData();
      // 上期
      const Sabnormal = await _this.GetYiCangTongJiData(-1);

      let TabnormalLists = [], SabnormalLists = [], abnormalNames = [];
      Tabnormal.forEach((item, index) => {
        TabnormalLists.push(item.value);
        abnormalNames.push(item.name);
      })
      Sabnormal.forEach((item, index) => {
        SabnormalLists.push(item.value);
      })

      _this.initEnergyEcharts(TabnormalLists, SabnormalLists, abnormalNames);
    },
    // 季异常事件
    async AbnormalBiliJi() {
      let _this = this;
      // 同期
      const Tabnormal = await _this.GetYiCangTongJiData();

      let TabnormalLists = [], SabnormalLists = [], abnormalNames = [];
      Tabnormal.forEach((item, index) => {
        if (index < 3) {
          SabnormalLists.push(item.value);
          TabnormalLists.push('-');
        } else {
          TabnormalLists.push(item.value);
          SabnormalLists.push('-');
        }
        abnormalNames.push(item.name);
      })

      _this.initEnergyEcharts(TabnormalLists, SabnormalLists, abnormalNames);

    },
    // 异常同比数据
    GetYiCangTongJiData(benQi = 0) {
      let _this = this;
      const abnormal = new Promise((resolve, reject) => {
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/GetYiCangTongJi?deviceCode=${_this.deviceItem.DeviceCode}&type=${_this.type}&benQi=${benQi}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function (res) {
          if (res.Success) {
            resolve(res.Data)
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      })
      return abnormal;
    },
    // 异常同比
    initEnergyEcharts(TabnormalLists, SabnormalLists, abnormalNames) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('initEnergyEcharts'))

      let series = [];
      if (_this.type == 'zi') {
        series = [{
          name: _this.$t('abnormal.abnormal.628134-26'),
          type: 'bar',
          barMaxWidth: '50',
          barMinHeight: 2,
          data: TabnormalLists
        }]
      } else {
        series = [{
          name: _this.$t('abnormal.abnormal.628134-26'),
          type: 'bar',
          barMaxWidth: '50',
          barMinHeight: 2,
          data: TabnormalLists
        },
        {
          name: _this.$t('abnormal.abnormal.628134-27'),
          type: 'bar',
          barMaxWidth: '50',
          barMinHeight: 2,
          data: SabnormalLists
        },
        ]
      }
      // 绘制图表
      myChart.setOption({
        color: ['#858FF8', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          top: '5%',
          right: '3%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: abnormalNames,
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ccc',
              fontSize: 10
            },
          },
          axisTick: { //y轴刻度线
            show: false
          },
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ccc',
              fontSize: 10
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.2)"
            }
          },
          axisTick: {
            show: false
          },
        }],
        series: series,
        dataZoom: {
          type: 'inside',
          start: 0,
          end: 100
        },
      });
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    // 根据设备编号获取异常
    GetDeviceAbnormalPageList() {
      let _this = this;
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/GetDeviceAbnormalPageList?deviceCode=${_this.deviceItem.DeviceCode}&pageIndex=${_this.DeviceAbnormalIndex}&pageSize=${_this.DeviceAbnormalSize}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          _this.DeviceAbnormalPageLists = res.Data;
          _this.DeviceAbnormalTotalCount = res.TotalCount;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    DeviceAbnormalChange(value) {
      let _this = this;
      _this.DeviceAbnormalIndex = value;
      _this.GetDeviceAbnormalPageList();
    },
    DeviceAbnormalSizeChange(value) {
      let _this = this;
      _this.DeviceAbnormalIndex = 1;
      _this.DeviceAbnormalSize = value;
      _this.GetDeviceAbnormalPageList();
    },
    // 查询
    inquireClick() {
      let _this = this;
      // 获取异常占比
      _this.YiCangZanBi();
      if (_this.type == 'zi') {
        // 根据时间进行异常统计
        _this.GetYiCangTongJiByDate();
      } else {
        _this.GetYiCangTongJi()
        if (_this.type == 'ji') {
          // 季异常
          _this.AbnormalBiliJi();
        } else {
          // 异常同比
          _this.AbnormalBili();
        }
      }
    },
    // 导出
    exportClick() {
      let _this = this;
      if (!Cookies.get('AdminData')) {
        if (window.location.host == 'xed.hxpwr.com') {
          this.$router.push({
            name: 'xed_login'
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
        return;
      }
      let dt = '';
      if (_this.type == 'zi') {
        if (!_this.times[0]) {
          _this.$Message['error']({
            background: true,
            content: _this.$t('abnormal.abnormal.628134-23')
          });
          return;
        }
        dt = `&startDt=${_this.formDate(_this.times[0])}&endDt=${_this.formDate(_this.times[1])}`;
      }
      let AdminData = JSON.parse(Cookies.get('AdminData'));
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'get',
        url: `api/YhjStatic/Export_DeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&deviceCode=${_this.deviceItem.DeviceCode}` + dt,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "Authorization": Cookies.get('Token')
        }
      }, 'yhj').then(function (res) {
        if (res.Success) {
          window.location.href = res.Data;
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },
    // 时间转换
    formDate(dateForm) {
      if (!dateForm) {
        return "";
      } else {
        var dateee = new Date(dateForm).toJSON();
        var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
          /\.[\d]{3}Z/, '');
        return date;
      }
    },
  }
}
</script>

<style scoped="scoped" lang="scss">@import url("./abnormal.css");
@import "../energy/energy_default.scss";
@import "../energy/energy.scss";</style>



// WEBPACK FOOTER //
// src/components/report/abnormal/abnormal.vue